import { render, staticRenderFns } from "./autodesk.vue?vue&type=template&id=14163183&scoped=true"
import script from "./autodesk.vue?vue&type=script&lang=js"
export * from "./autodesk.vue?vue&type=script&lang=js"
import style0 from "./autodesk.vue?vue&type=style&index=0&id=14163183&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14163183",
  null
  
)

export default component.exports